import React, { useState, useRef, useEffect } from 'react';
import appLogo from '../assets/Apps.svg';
import stackLogo from '../assets/stack.svg';

const EntityDropdown = ({ entityList, selectedEntity, onSelectEntity, customDetails }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelectEntity = (entity) => {
    onSelectEntity(entity);
    setIsOpen(false);
  };

  // Render individual Entity option
  const renderEntityOption = (entity, isSelected = false) => (
    <div
      key={entity.name}
      className={`d-flex align-items-center p-2 ${!isSelected ? 'entity-option' : ''}`}
      style={{
        cursor: !isSelected ? 'pointer' : 'default',
        borderBottom: !isSelected ? '1px solid #f0f0f0' : 'none',
        backgroundColor: isSelected ? 'transparent' : 'white',
        minHeight: '40px',
      }}
      onClick={!isSelected ? () => handleSelectEntity(entity) : undefined}
    >
      {/* Entity Logo */}
      <div className="flex-shrink-0" style={{ width: '24px', height: '24px', marginLeft:'5px' ,marginBottom:'2.5px', marginRight: '8px'}}>
          <img
            src={entity.name === 'All' ? stackLogo : (entity.entityLogoUri || appLogo)}  
            className="w-100 h-100 rounded"
            style={{
              objectFit: 'contain'
            }}
            onError={(e) => {
              // Fallback if image fails to load
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
      </div>

      {/* Entity Details */}
      <div className="flex-grow-1">
        <div style={{ fontSize: '12px', color: customDetails?.primaryBtnColor, textAlign: 'left' }}>
          <span className="fw-600">{entity.name}</span>
          {entity.count !== undefined && (
            <span className="ms-2" style={{ color: '#828282' }}>
              ({entity.count})
            </span>
          )}
        </div>
      </div>

      {isSelected && (
        <div className="ms-2">
          {/* CSS-based chevron */}
          <div
            style={{
              width: '12px',
              height: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease',
            }}
          >
            <div
              style={{
                width: '4px',
                height: '4px',
                borderRight: `1px solid ${customDetails?.primaryBtnColor}`,
                borderBottom: `1px solid ${customDetails?.primaryBtnColor}`,
                transform: 'rotate(45deg)',
                marginTop: '-1px',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );

  if (!entityList || entityList.length === 0) {
    return null;
  }

  // If only one entity, don't show dropdown
  return (
    <div
      className="mb-3 mb-md-0 position-relative entity-dropdown-container"
      ref={dropdownRef}
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: '20px',
        border: '2px solid #D9D9D9',
      }}
    >
      {/* Always render the selected Entity */}
      <div
        onClick={entityList.length > 1 ? toggleDropdown : undefined}
        className="rounded"
        style={{
          cursor: entityList.length > 1 ? 'pointer' : 'default'
        }}
      >
        {renderEntityOption(
          entityList.length === 1 ? entityList[0] : selectedEntity,
          true
        )}
      </div>
  
      {/* Render dropdown only if more than one entity */}
      {entityList.length > 1 && isOpen && (
        <div
          className="position-absolute w-100 bg-white border rounded shadow mt-1"
          style={{
            top: '100%',
            left: '0',
            zIndex: 1000,
            maxHeight: '300px',
            overflowY: 'auto',
          }}
        >
          {entityList
            .filter(entity => entity.name !== selectedEntity?.name)
            .map(entity => renderEntityOption(entity, false))
          }
        </div>
      )}
  
      <style jsx>{`
        .entity-option:hover {
          background-color: var(--bs-light) !important;
        }
        .entity-dropdown-container {
          flex: 1;
          min-width: 200px;
          border-radius: 3rem;
        }
        @media (max-width: 600px) {
          .entity-dropdown-container {
            flex: 1 1 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default EntityDropdown;

